import { db } from "../firebaseClient"
import { doc, collection, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore"
import { dateKeyFor } from "./dateRangeHelpers"

// Append-only — unlike enrollment fields (which get overwritten), this is the
// only place that can answer "how many lessons were completed on Tuesday."
export const logLearningEvent = async ({ orgId, userId, courseId, type }) => {
  if (!orgId || !userId || !type) return { error: null }
  try {
    const ref = doc(collection(db, "learningEvents"))
    await setDoc(ref, {
      orgId,
      userId,
      courseId: courseId || null,
      type, // "lesson_completed" | "assessment_completed"
      dateKey: dateKeyFor(new Date()),
      createdAt: serverTimestamp(),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listOrgLearningEvents = async (orgId) => {
  try {
    const ref = collection(db, "learningEvents")
    const q = query(ref, where("orgId", "==", orgId))
    const snap = await getDocs(q)
    return { events: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { events: [], error }
  }
}

// Learner-facing: every learning event for this user across all orgs —
// flat collection, no org filter needed. Powers the dashboard's Learning
// Momentum strip.
export const listLearnerLearningEvents = async (userId) => {
  if (!userId) return { events: [], error: null }
  try {
    const ref = collection(db, "learningEvents")
    const q = query(ref, where("userId", "==", userId))
    const snap = await getDocs(q)
    return { events: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { events: [], error }
  }
}